<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                    <i class="fas fa-hand-holding-usd"></i>
                        Enviar
                    </h2>
                </div>
                <Balance :short="true"/>
            </div>
        </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <section class="mx-4 xl:mx-32 lg:mx-20 md:mx-3 xl:mt-16 lg:mt-16 md:mt-6 sm:mt-6 mt-4">
                <Flash :timeout="5000" />
                <Slider v-if="showSlider" :stages="sliderStages" />
                <div class="px-5">
                    <SelectKey
                        v-show="sections.selectKey"
                        :contacts="contacts"
                        :get-info-key="getInfoKey"
                        @back="$emit('back')"
                        @next="next"
                        @refresh-contacts="getContacts"
                    />
                    <FormValueDetails
                        v-if="sections.valueDetails"
                        :favored="favored"
                        @go-back="goBack"
                        @next="submitPix"
                    />
                </div>
            </section>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout.vue";
import SelectKey from "./SelectKey.vue";
import FormValueDetails from "./FormValueDetails.vue";
import Slider from "./../components/Slider.vue";
import Balance from "../../../Helpers/Balance.vue";
import Flash from '../../../Helpers/Flash.vue';

export default {
    name: "Pix",
    data: () => ({
        showSlider: true,
        sections: {
            selectKey: false,
            valueDetails: false,
        },
        contacts: {
            data: [],
            loading: false
        },
        favored: {}
    }),
    computed: {
        sliderStages(){
            return [{
                    titleStage: 'Modalidade de envio',
                    percentage: '0%',
                    selected: false,
                    completed: true
                },
                {
                    titleStage: 'Chave pix',
                    percentage: '50%',
                    selected: this.sections.selectKey,
                    completed: this.sections.valueDetails,
                },
                {
                    titleStage: 'Valor e detalhes',
                    percentage: '98.7%',
                    selected: this.sections.valueDetails,
                    completed: this.sections.valueDetails,
                }]
        }
    },
    methods: {
        submitPix(){
            this.sections.valueDetails = false
            this.showSlider = false
        },
        next(){
            this.sections.selectKey = false
            this.sections.valueDetails = true
        },
        goBack(){
            this.sections.selectKey = true
            this.sections.valueDetails = false
        },
        contactsFormatData(contactsRoot = []){
            return contactsRoot.map((contact) => ({
                ...contact,
                initialsName: (() => /(\w)\w+\s(\w)/g.exec(contact.customer).slice(1))().join(''),
                bgItemList: this.getItemBackgroundByInitial((() => /(\w)\w+\s(\w)/g.exec(contact.customer).slice(1))().join('')),
                key: this.formatkey(contact.key),
                rootkey: contact.key,
                name: contact.customer,
            }))
        },
        getItemBackgroundByInitial(name){
            const firstAlphabet = name.charAt(0).toLowerCase();
            const asciiCode = firstAlphabet.charCodeAt(0);
            const colorNum = asciiCode.toString() + asciiCode.toString() + asciiCode.toString();

            const num = Math.round(0xffffff * parseInt(colorNum));
            const r = num >> 16 & 255;
            const g = num >> 8 & 255;
            const b = num & 255;

            return 'rgb(' + r + ', ' + g + ', ' + b + ', 0.8)';
        },
        formatkey(key){
            if(key.includes('+55'))return this.$options.filters.formatPhone(key)
            if(key.includes('@')) return key

            const lengthDocument = key.length
            if(lengthDocument === 11 || lengthDocument === 14) return this.$options.filters.federalDocument(key)
            return key
        },
        async getInfoKey(customer){
            try{
                const { data } = typeof customer.isPhone !== 'undefined'
                ? await axios.get(`/json/pix/key/validate?key=${customer.key}&key_phone=${customer.isPhone}`)
                : await axios.get(`/json/pix/key/validate?key=${customer.key}`)

                if(data.error){
                    return data.error
                }
                this.favored = { ...data, ...customer}
                this.next()
            }catch(error){
                return 'Chave PIX inválida'
            }
        },
        async getContacts(){
            this.contacts.loading = true
            const { data } = await axios.get('/json/pix/recent-transfers')
            this.contacts.data = this.contactsFormatData(data.recent_pix_transfers.filter(contact => !!contact))
            this.contacts.loading = false
        }
    },
    beforeMount() {
        setTimeout(() => (this.sections.selectKey = true), 0);
        this.getContacts()
    },
    components: {
        AppLayout,
        SelectKey,
        FormValueDetails,
        Slider,
        Balance,
        Flash
    }
};
</script>
